export enum AuthTokenType {
    EditorLowPrivilege,
    AugLoopLowPrivilege,
    Anonymous,
    ClientAssertion,
    ClientAssertionV2,
    AutoClpLowPrivilege,
    AutoClpAppOnlyLowPrivilege,
    Substrate,
    WacAutoClpUserInfo,
    OwaExchange,
    SmartCompose,
    WritingAnalyticsLowPrivilege,
    DWEngineLowPrivilege,
    SubstrateApp,
    CortanaAppPop,
    OfficeAppsAppOnly,
    PPTFrontdoorAppPop,
    EditorAppOnlyLowPrivilege
}

export enum UserType {
    Unknown,
    Consumer,
    Enterprise
}
